import { createContext, useContext, useMemo, createElement, } from 'react';
var ErrorContext = createContext(null);
export var ErrorProvider = ErrorContext.Provider;
export function useErrorContext(path) {
    var error = useContext(ErrorContext);
    return useMemo(function () {
        if (!path) {
            return error;
        }
        else {
            return error && typeof error === 'object'
                ? error[path] || get(error, path)
                : null;
        }
    }, [error, path]);
}
export var ChildErrorProvider = function (_a) {
    var path = _a.path, children = _a.children;
    var value = useErrorContext(path);
    return createElement(ErrorProvider, { value: value, children: children });
};
function get(obj, path) {
    var segments = path.split('.');
    var _loop_1 = function (segment) {
        if (obj == null)
            return { value: obj };
        if (Array.isArray(obj)) {
            var index = parseInt(segment);
            if (!isNaN(index)) {
                obj = obj[index];
            }
            else {
                var match_1 = segment.match(/^\[([a-zA-Z0-9_-]+):([^\]]+)\]$/);
                if (match_1) {
                    obj = obj.find(function (x) { return x != null && x[match_1[1]] === match_1[2]; });
                }
                else {
                    obj = obj[segment];
                }
            }
        }
        else {
            obj = obj[segment];
        }
    };
    for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
        var segment = segments_1[_i];
        var state_1 = _loop_1(segment);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return obj;
}
//# sourceMappingURL=ErrorContext.js.map